import positions from "../../constants/positions";
import {
  tooltipFitsBottom,
  tooltipFitsLeft,
  tooltipFitsRight,
  tooltipFitsTop
} from "../fitsPosition";

const orderedPositions = [
  positions.TOP,
  positions.RIGHT,
  positions.BOTTOM,
  positions.LEFT
];

const positionRules = {
  [positions.BOTTOM]: tooltipFitsBottom,
  [positions.LEFT]: tooltipFitsLeft,
  [positions.RIGHT]: tooltipFitsRight,
  [positions.TOP]: tooltipFitsTop
};

const fitsPosition = ({ position, spacer, tooltipElem, triggerElem }) =>
  positionRules[position]({
    spacer,
    tooltipElem,
    triggerElem
  });

export default ({ preferredPosition, spacer, tooltipElem, triggerElem }) => {
  const startingIndex = orderedPositions.indexOf(preferredPosition);

  const positionCandidates = [
    ...orderedPositions.slice(startingIndex),
    ...orderedPositions.slice(0, startingIndex)
  ];

  const firstFittingPosition = positionCandidates.find(position =>
    fitsPosition({ position, spacer, tooltipElem, triggerElem })
  );

  return firstFittingPosition ?? preferredPosition;
};
